/**
 * @desc 分页
 */
const URL = "/rantion-crawler";
import http, { updateResponse } from "@/http";
export function request(params: API.crawler.crawlerTask.page.Params, options?: any) {
  return updateResponse(
    http(URL + `/crawlerTask/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
